import { render } from "./CalculateProductsCount.vue?vue&type=template&id=184d9f0a"
import script from "./CalculateProductsCount.vue?vue&type=script&lang=js"
export * from "./CalculateProductsCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__